import Card from '@/components/atoms/Card';
import { Divider } from '@/components/atoms/Divider';
import ImageStrapi from '@/components/atoms/Image/ImageStrapi';
import { Text } from '@/components/atoms/Text';
import { useTranslation } from '@/lib/i18n/i18n.client';
import { cn } from '@/lib/utils';
import { Testimonial } from '../Testimonials';

type Props = {
  testimonial: Testimonial;
};

const CompanyInfo = ({ testimonial }: Props) => {
  const { texts } = useTranslation();

  return (
    <Card
      classNames={{
        root: cn(
          'bg-base-white w-full  border-none',
          'flex flex-col content-between',
          'lg:w-80',
          'px-6 py-8 lg:px-10 lg:py-10 lg:pr-6'
        ),
      }}
    >
      <ImageStrapi
        block={testimonial?.logo}
        inner={{
          classNames: {
            container: 'flex h-5 text-left',
            image: 'object-left',
          },
        }}
        height={20}
        width={128}
      />
      <Divider
        showOnDark
        alignment='horizontal'
        classNames={{ root: cn('lg:mt-20 mt-10', 'mb-6') }}
      />
      <div
        className={cn(
          'flex flex-col flex-1 text-left justify-between',
          'gap-y-8 lg:gap-y-12'
        )}
      >
        <div className='flex-1'>
          <Text
            classNames={{
              wrapper: 'mb-3 text-gray-500 font-serif uppercase',
            }}
            variant='label'
          >
            {texts.testimonials.companySize}
          </Text>
          <Text variant='body-l'>{testimonial.companySize}</Text>
        </div>
        <div className='flex-1'>
          <Text
            classNames={{
              wrapper: 'mb-3 text-gray-500 font-serif uppercase',
            }}
            variant='label'
          >
            {texts.testimonials.industry}
          </Text>
          <Text variant='body-l'>{testimonial.industry}</Text>
        </div>
      </div>
    </Card>
  );
};

export default CompanyInfo;
